module.exports = __webpack_public_path__ + "static/media/es-ES.f4eea22b.md";